import compose from 'lodash/fp/compose';

import { canAdd, canUpdate, paginate } from '../plugins';
import ordersApi from '../../firebase/orders';
import PluggableModule from '../pluggable';

const orders = new PluggableModule('order');

orders.extend({
  namespaced: true,
  actions: {
    async addOrders({ commit }, data) {
      commit(orders.con.ORDER_SUBMIT_INIT);
      try {
        const ref = await ordersApi.add(data);
        commit(orders.con.ORDER_CREATED, ref.id);
        commit(orders.con.ORDER_SUBMIT_DONE);
      } catch (error) {
        commit(orders.con.ORDER_SUBMIT_DONE);
        throw error;
      }
    }
  }
});

const hop = compose(
  canAdd(),
  canUpdate(),
  paginate('orders', {
    filterDefinition: {
      createdAt: 'orderBy',
      user: 'reference'
    },
    filterDefault: {
      createdAt: 'desc'
    }
  })
);

export default hop(orders);
